// eslint-disable-next-line no-unused-vars
import { IOption } from 'shared/FormikField/FormikField.model';
import { ADD_ORDER_TYPE } from 'pages/WirelineEngagements/WirelineEngagements.models';
import { BRAND_NAMES } from 'core/whiteLabel/whiteLabel';

const createOrderNotifier = {
  success: 'Order created successfully',
  error: 'Failed to create order',
};

export enum fields {
  tsdId = 'tsdId',
  orders = 'orders',
  carrier = 'carrier',
  params = 'params',
  products = 'products',
  productId = 'productId',
  currentTSD = 'currentTSD',
  categoryId = 'categoryId',
  productName = 'productName',
  locationIds = 'locationIds',
  sellerRequestType = 'sellerRequestType',
  contractSupport = 'contractOrderSupport',
  projectManagementSupport = 'projectManagementSupport',
  customerAssistPm = 'customerAssistPm',
  billingSupport= 'billingSupport',
  customerAssistBilling = 'customerAssistBilling',
}

export const ATAndTLabel = 'AT&T';
export const nonATAndTCategoryLabel = 'Non AT&T';

export enum sellerRequestTypeValues {
  billingSuport = 'BILLING_SUPPORT',
  contractSupport = 'CONTRACT_SUPPORT',
  projectManagerSupport = 'PROJECT_MANAGER_SUPPORT',
}

export const sellerRequestTypeLabels = {
  [sellerRequestTypeValues.billingSuport]: 'Billing Support',
  [sellerRequestTypeValues.contractSupport]: 'Contract/order support',
  [sellerRequestTypeValues.projectManagerSupport]: 'Project Management Support',
};

export const newOrdersSellerRequestTypeATTOptions: IOption[] = [
  {
    label: sellerRequestTypeLabels[sellerRequestTypeValues.contractSupport],
    value: sellerRequestTypeValues.contractSupport,
  },
  {
    label: sellerRequestTypeLabels[sellerRequestTypeValues.projectManagerSupport],
    value: sellerRequestTypeValues.projectManagerSupport,
  },
  {
    label: sellerRequestTypeLabels[sellerRequestTypeValues.billingSuport],
    value: sellerRequestTypeValues.billingSuport,
  },
];

export const newOrdersSellerRequestTypeNonATTOptions: IOption[] = [
  {
    label: sellerRequestTypeLabels[sellerRequestTypeValues.contractSupport],
    value: sellerRequestTypeValues.contractSupport,
  },
];

export const renewelOrderSellerRequestType: IOption[] = [
  {
    label: sellerRequestTypeLabels[sellerRequestTypeValues.contractSupport],
    value: sellerRequestTypeValues.contractSupport,
  },
  {
    label: sellerRequestTypeLabels[sellerRequestTypeValues.billingSuport],
    value: sellerRequestTypeValues.billingSuport,
  },
];

export enum contractSuportValues {
  new = 'NEW',
  reOrder = 'RE_ORDER',
  renewal = 'RENEWAL',
  canceled = 'CANCELED',
}

export const contractOrderSupportLabels = {
  [contractSuportValues.new]: 'New',
  [contractSuportValues.reOrder]: 'Re-order',
  [contractSuportValues.renewal]: 'Renewal',
  [contractSuportValues.canceled]: 'Canceled',
};

export const newOrderContractSupportOptions: IOption[] = [
  {
    label: contractOrderSupportLabels[contractSuportValues.new],
    value: contractSuportValues.new,
  },
  {
    label: contractOrderSupportLabels[contractSuportValues.reOrder],
    value: contractSuportValues.reOrder,
  },
];

export const renewelOrderContractSupportOptions: IOption[] = [
  {
    label: contractOrderSupportLabels[contractSuportValues.renewal],
    value: contractSuportValues.renewal,
  },
];

export enum projectManagerSupportValues {
  orderProcessedByNetSpark = 'ORDER_PROCESSED_BY_NETSPARK',
  customerAssistPM = 'CUSTOMER_ASSIST_OR_PM',
}

export const projectManagementSupportLabelsNetSpark = {
  [projectManagerSupportValues.customerAssistPM]: 'Customer Assist/PM',
  [projectManagerSupportValues.orderProcessedByNetSpark]: 'Order processed by NetSpark',
};

export const projectManagementSupportLabelsDefault = {
  [projectManagerSupportValues.customerAssistPM]: 'Customer Assist/PM',
  [projectManagerSupportValues.orderProcessedByNetSpark]: 'Order processed internally',
};

export const projectManagerSupportOptionsDefault: IOption[] = [
  {
    label: projectManagementSupportLabelsDefault[
      projectManagerSupportValues.orderProcessedByNetSpark
    ],
    value: projectManagerSupportValues.orderProcessedByNetSpark,
  },
  {
    label: projectManagementSupportLabelsDefault[projectManagerSupportValues.customerAssistPM],
    value: projectManagerSupportValues.customerAssistPM,
  },
];

export const projectManagerSupportOptionsNetSpark: IOption[] = [
  {
    label: projectManagementSupportLabelsNetSpark[
      projectManagerSupportValues.orderProcessedByNetSpark
    ],
    value: projectManagerSupportValues.orderProcessedByNetSpark,
  },
  {
    label: projectManagementSupportLabelsNetSpark[projectManagerSupportValues.customerAssistPM],
    value: projectManagerSupportValues.customerAssistPM,
  },
];

export const brandProjectManagerSupportOptions = {
  [BRAND_NAMES.NETSPARK]: projectManagerSupportOptionsNetSpark,
  default: projectManagerSupportOptionsDefault,
};

export enum billingSupportValues {
  orderProcessedByNetSpark = 'ORDER_PROCESSED_BY_NETSPARK',
  customerAssistBilling = 'CUSTOMER_ASSIST_OR_BILLING',
}

export const billingSupportLabelsNetSpark = {
  [billingSupportValues.customerAssistBilling]: 'Customer Assist/Billing',
  [billingSupportValues.orderProcessedByNetSpark]: 'Order processed by NetSpark',
};

export const billingSupportLabelsDefault = {
  [billingSupportValues.customerAssistBilling]: 'Customer Assist/Billing',
  [billingSupportValues.orderProcessedByNetSpark]: 'Order processed internally',
};

export const billingSupportOptionsNetSpark: IOption[] = [
  {
    label: billingSupportLabelsNetSpark[billingSupportValues.orderProcessedByNetSpark],
    value: billingSupportValues.orderProcessedByNetSpark,
  },
  {
    label: billingSupportLabelsNetSpark[billingSupportValues.customerAssistBilling],
    value: billingSupportValues.customerAssistBilling,
  },
];

export const billingSupportOptionsDefault: IOption[] = [
  {
    label: billingSupportLabelsDefault[billingSupportValues.orderProcessedByNetSpark],
    value: billingSupportValues.orderProcessedByNetSpark,
  },
  {
    label: billingSupportLabelsDefault[billingSupportValues.customerAssistBilling],
    value: billingSupportValues.customerAssistBilling,
  },
];

export const brandBillingSupportOptions = {
  [BRAND_NAMES.NETSPARK]: billingSupportOptionsNetSpark,
  default: billingSupportOptionsDefault,
};

export const addOrdersFieldsPlaceholders = {
  billingSupport: 'Billing Support',
  customerAssistPm: 'Customer Assist/PM',
  contractSupport: 'Contract/order support',
  customerAssistBilling: 'Customer Assist/Billing',
  projectManagementSupport: 'Project Management Support',
};

export const schemaNewOrderSellerRequestType = {
  [sellerRequestTypeValues.contractSupport]: {
    type: 'select',
    fieldName: fields.contractSupport,
    placeholder: addOrdersFieldsPlaceholders.contractSupport,
    options: { default: newOrderContractSupportOptions },
  },
  [sellerRequestTypeValues.projectManagerSupport]: {
    type: 'select',
    fieldName: fields.projectManagementSupport,
    placeholder: addOrdersFieldsPlaceholders.projectManagementSupport,
    options: brandProjectManagerSupportOptions,
    nested: {
      [projectManagerSupportValues.customerAssistPM]: {
        type: 'text',
        fieldName: fields.customerAssistPm,
        placeholder: addOrdersFieldsPlaceholders.customerAssistPm,
      },
    },
  },
  [sellerRequestTypeValues.billingSuport]: {
    type: 'select',
    fieldName: fields.billingSupport,
    placeholder: addOrdersFieldsPlaceholders.billingSupport,
    options: brandBillingSupportOptions,
    nested: {
      [billingSupportValues.customerAssistBilling]: {
        type: 'text',
        fieldName: fields.customerAssistBilling,
        placeholder: addOrdersFieldsPlaceholders.customerAssistBilling,
      },
    },
  },
};

export const schemaRenewelOrderSellerRequestType = {
  [sellerRequestTypeValues.contractSupport]: {
    type: 'select',
    fieldName: fields.contractSupport,
    placeholder: addOrdersFieldsPlaceholders.contractSupport,
    options: { default: renewelOrderContractSupportOptions },
  },
  [sellerRequestTypeValues.billingSuport]: {
    type: 'select',
    fieldName: fields.billingSupport,
    placeholder: addOrdersFieldsPlaceholders.billingSupport,
    options: brandBillingSupportOptions,
    nested: {
      [billingSupportValues.customerAssistBilling]: {
        type: 'text',
        fieldName: fields.customerAssistBilling,
        placeholder: addOrdersFieldsPlaceholders.customerAssistBilling,
      },
    },
  },
};

export const schemaSellerRequestType = {
  [ADD_ORDER_TYPE.NEW_ORDER]: schemaNewOrderSellerRequestType,
  [ADD_ORDER_TYPE.RENEWAL_ORDER]: schemaRenewelOrderSellerRequestType,
};

export interface ISchemaSellerRequestTypeOptions {
  [key: string]: IOption[];
  default: IOption[];
}

export interface ISchemaSellerRequestType {
  type: string;
  fieldName: string;
  placeholder: string;
  options: ISchemaSellerRequestTypeOptions;
  nested?: ISchemaSellerRequestType;
}

export default createOrderNotifier;
